import React from 'react';
import i18n from 'i18next';
import { PatrolExact } from '../../../models/Patrol';
import useStyles from './MissionName.styles';

const MissionName = ({ patrol }) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <div className={classes.title}>{i18n.t('patrol.id')}</div>
        <div className={classes.text}>{patrol.id}</div>
      </div>
      <div>
        <div className={classes.title}>{i18n.t('common.entity.mission')}</div>
        <div className={classes.text}>{patrol.isMissionDeleted ? `${patrol.missionName} (${i18n.t('patrol.deleted')})` : patrol.missionName}</div>
      </div>
      <div>
        <div className={classes.title}>{i18n.t('common.entity.client')}</div>
        <div className={classes.text}>{patrol.clientName}</div>
      </div>
    </div>
  );
};

MissionName.propTypes = {
  patrol: PatrolExact.isRequired,
};

MissionName.defaultProps = {};

export default MissionName;
